import api from '../../api';

const fetchSettings = (id = '', params) => api.get(`/settings${id !== ''? `/${id}` : ''}`,params);

export {
    fetchSettings
};